/* src/app/admin-dashboard/kunde-kort/kunde-kort-board/kunde-kort-board.component.css */
.kkb-board {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  overflow-x: auto;
  padding: 4px 4px 24px;
}
.kkb-column {
  flex: 0 0 280px;
  width: 280px;
  background: #f4f5f7;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 220px);
}
.kkb-column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-radius: 8px 8px 0 0;
  font-weight: 600;
  font-size: 14px;
  color: #fff;
}
.kkb-header--lead {
  background: #64748b;
}
.kkb-header--prospect {
  background: #d97706;
}
.kkb-header--active {
  background: #16a34a;
}
.kkb-header--inactive {
  background: #94a3b8;
}
.kkb-column-count {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 999px;
  padding: 1px 9px;
  font-size: 12px;
}
.kkb-column-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 10px;
  min-height: 60px;
}
.kkb-card {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  padding: 10px 12px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: box-shadow 0.15s ease;
}
.kkb-card:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
}
.kkb-card-name {
  font-weight: 600;
  font-size: 14px;
  color: #0f172a;
}
.kkb-card-sub {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
  word-break: break-word;
}
.kkb-card-type {
  display: inline-block;
  margin-top: 6px;
  font-size: 11px;
  font-weight: 500;
  color: #3730a3;
  background: #eef2ff;
  border-radius: 999px;
  padding: 1px 8px;
}
.kkb-empty {
  font-size: 12px;
  color: #94a3b8;
  text-align: center;
  padding: 16px 0;
}
.cdk-drag-preview {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
}
.cdk-drag-placeholder {
  opacity: 0.3;
}
.cdk-drop-list-dragging .kkb-card:not(.cdk-drag-placeholder) {
  transition: transform 0.15s cubic-bezier(0, 0, 0.2, 1);
}
/*# sourceMappingURL=kunde-kort-board.component.css.map */
